import { render, staticRenderFns } from "./SelfEvaluation.vue?vue&type=template&id=3aab5cb0&scoped=true"
import script from "./SelfEvaluation.vue?vue&type=script&lang=js"
export * from "./SelfEvaluation.vue?vue&type=script&lang=js"
import style0 from "./SelfEvaluation.vue?vue&type=style&index=0&id=3aab5cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab5cb0",
  null
  
)

/* custom blocks */
import block0 from "./SelfEvaluation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports